import React, { useEffect, useState } from "react";
import MobileNav from "./MobileNav";
import Navbar from "./Navbar";
import HeaderTop from "./HeaderTop";
import { Link } from "react-router-dom";
import '../css/header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the scroll threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={isScrolled ? "header scrolled" : "header"}>
      <div className="nav-area">
        <div className="header-logo-main">
        <Link to="/" className="logo">
          <img src="/img/Sanskar_Logo_new.webp" alt="Website Logo" />
         
        
 
          
        </Link>
            {/* <div className="ib-header-logo"> */}
          {/* <img src="/img/ib-herader-logo.png" alt="Website Logo" /> */}
          {/* <img src="/img/ib-herader-logo3.webp" alt="Website Logo" /> */}
        {/* </div> */}

        </div>
       
        <Navbar />
        <MobileNav />
      </div>
    </header>
  );
};

export default Header;
